import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bc91606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle no-mb" }
const _hoisted_2 = { class: "subtitle no-mb" }
const _hoisted_3 = {
  key: 1,
  class: "no-mb"
}

import { onMounted, ref } from 'vue'
import { WarningOutlined } from '@ant-design/icons-vue'

interface SummaryProduct {
  reference:string
  commercial_name:string
  is_excluded_from_warranty:boolean
  qty:string
  unit_price_text:string
  price_text:string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononSummaryProductsTable',
  props: {
    products: null,
    showPartOf: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { products:SummaryProduct[], showPartOf?:boolean };



const columns = ref([
  { title: 'Product', key: 'product' },
  { title: 'Aantal', key: 'qty', width: 100 },
  { title: 'Eenheidsprijs', key: 'unit_price', width: 150 },
  { title: 'Prijs', key: 'price', width: 150 }
])

onMounted(() => {
  if (props.showPartOf) {
    columns.value.splice(1, 0, { title: 'Onderdeel van', key: 'partOf' })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!

  return (__props.products.length)
    ? (_openBlock(), _createBlock(_component_a_table, {
        key: 0,
        columns: columns.value,
        "data-source": __props.products,
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key === 'product')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(record.commercial_name) + " ", 1),
                (record.is_excluded_from_warranty)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "right"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode("Let op! Dit product is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningOutlined), { style: {"color":"#f38929","margin-left":"8px"} })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_1, _toDisplayString(record.reference), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'partOf')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(record.part_of_text), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'qty')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(record.qty), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'unit_price')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(record.unit_price_text), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'price')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(record.price_text) + " ", 1),
                _createElementVNode("p", _hoisted_2, "incl. " + _toDisplayString(record.vat_rate_text) + " BTW", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source"]))
    : (_openBlock(), _createElementBlock("p", _hoisted_3, "Er is door u (nog) geen meer- minderwerk gekozen voor deze fase."))
}
}

})